<template>
  <div>
    <div class="text-left mt-5">
      <b-row>
        <b-col md="4">
          <h5 class="text-primary">
            <b>Shortener URLs</b>
          </h5>
        </b-col>
        <b-col></b-col>
        <b-col md="6" align="right">
          <b-row>
            <b-col md="4">
              <b-button
                variant="primary"
                @click="showModalCreate()"
                size="md"
                block
              >
                Create
              </b-button>
            </b-col>
            <b-col md="4" class="my-1" align="right">
              <b-form-group label-cols-sm="6" label="Show" class="mb-0 mr-3">
                <b-form-select
                  v-model="perPage"
                  :options="pageOptions"
                >
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-input-group style="justify-content: end">
                <b-input-group-text
                  class="bg-white border-right-0"
                  slot="prepend"
                >
                  <img src="@/assets/filter.svg" alt />
                </b-input-group-text>
                <b-dropdown
                  text="Filter Data"
                  variant="light"
                  toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
                  slot="append"
                >
                  <div class="p-3">
                    <b-row>
                      <b-col md="6">
                        <b-form-group
                          id="search-field-group"
                          label="Search"
                          class="font-weight-bold"
                          label-for="search-field"
                        >
                          <input
                            id="search-field"
                            placeholder="Search"
                            v-model="search_param"
                            name="search"
                            type="text"
                            data-vv-as="Search"
                            class="form-control"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <b-form-group
                          id="date-field-group"
                          label="Create Period"
                          class="font-weight-bold"
                          label-for="input-1"
                        >
                          <b-row>
                            <b-col>
                              <b-row class="m-0">
                                <b-col
                                  class="
                                    pr-0
                                    form-control form-control-sm
                                    img-calender-select
                                    border-right-0
                                  "
                                  md="4"
                                >
                                  <img
                                    src="@/assets/ic-calendar-copy-30.svg"
                                    width="20px"
                                    alt
                                    class="mt-n1"
                                  />
                                </b-col>
                                <b-col md="6" class="px-0">
                                  <datepicker
                                    input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                                    placeholder="Select Date"
                                    v-model="createdAtStart"
                                    :format="customFormatter"
                                    :disabledDates="disabledDatesStart"
                                  >
                                  </datepicker>
                                </b-col>
                                <b-col align="left" md="1" class="px-0">
                                  <b-col
                                    align="left"
                                    class="
                                      px-4
                                      form-control form-control-sm
                                      del-calender-select
                                      border-left-0
                                    "
                                    md="2"
                                  >
                                    <b-row align="left">
                                      <b-col>
                                        <b-button
                                          class="
                                            m-0
                                            p-0
                                            mt-n1
                                            bg-transparent
                                            border-0
                                          "
                                          @click="resetDateCreatedStart"
                                          variant="outline-light"
                                        >
                                        <i
                                          class="text-danger fas fa-times"
                                        ></i>
                                        </b-button>
                                      </b-col>
                                    </b-row>
                                  </b-col>
                                </b-col>
                              </b-row>
                            </b-col>
                            <b-col>
                              <b-row class="m-0">
                                <b-col
                                  class="
                                    pr-0
                                    form-control form-control-sm
                                    img-calender-select
                                    border-right-0
                                  "
                                  md="4"
                                >
                                  <img
                                    src="@/assets/ic-calendar-copy-30.svg"
                                    width="20px"
                                    alt
                                    class="mt-n1"
                                  />
                                </b-col>
                                <b-col md="6" class="px-0">
                                  <datepicker
                                    input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                                    placeholder="Select Date"
                                    calendar-class="calender-margin"
                                    v-model="createdAtEnd"
                                    :format="customFormatter"
                                    :disabledDates="disabledDatesEnd"
                                  ></datepicker>
                                </b-col>
                                <b-col align="left" md="1" class="px-0">
                                  <b-col
                                    align="left"
                                    class="
                                      px-4
                                      form-control form-control-sm
                                      del-calender-select
                                      border-left-0
                                    "
                                    md="2"
                                  >
                                    <b-row align="left">
                                      <b-col>
                                        <b-button
                                          class="
                                            m-0
                                            p-0
                                            mt-n1
                                            bg-transparent
                                            border-0
                                          "
                                          @click="resetDateCreatedEnd"
                                          variant="outline-light"
                                        >
                                          <i
                                            class="text-danger fas fa-times"
                                          ></i>
                                        </b-button>
                                      </b-col>
                                    </b-row>
                                  </b-col>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <br />
                    <b-row style="text-align-last: right">
                      <b-col>
                        <b-button
                          variant="outline-secondary"
                          @click="resetSearch()"
                          class="mr-3"
                          >Set Ulang</b-button
                        >
                        <b-button variant="primary" @click="search()"
                          >Cari</b-button
                        >
                      </b-col>
                    </b-row>
                  </div>
                  <b-dropdown-item
                    class="pointer-off"
                    style="width: 450px"
                  ></b-dropdown-item>
                </b-dropdown>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <b-row>
        <b-col>
          <section v-if="errored">
            <p>
              We're sorry, we're not able to retrieve this information at the
              moment, please try back later
            </p>
          </section>
          <b-table
            v-else
            show-empty
            hover
            ref="selectableTable"
            responsive="sm"
            stacked="md"
            head-variant="light"
            class="bg-white"
            :items="getInfo"
            :fields="key"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <div slot="table-busy" class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
            <template v-slot:cell(created_date_with_time)="row">
              <label>{{ row.value | DateTime }}</label>
            </template>
            <template v-slot:cell(url)="row">
              <div>
                {{
                  row.value ? (row.value.length > 50 ? row.value.substring(0, 50) + "..." : row.value) : ""
                }}&nbsp;
              </div>
            </template>
            <template v-slot:cell(action)="{ item }">
              <b-link
                v-b-tooltip.hover
                title="View Detail"
                @click="showModalUpdate(item)"
                class="text-dark"
              >
                <img class="mr-2" src="@/assets/ic-view-detail.svg" alt />
              </b-link>
              <b-link
                v-b-tooltip.hover
                title="Delete"
                class="mr-2"
                @click="del(item)"
              >
                <img src="@/assets/rectangle.svg" alt />
              </b-link>
            </template>
          </b-table>
          <b-row class="mx-auto">
            <b-col md="4" class="mx-auto px-0"
              >Total entries {{ totalRows }}</b-col
            >
            <b-col md="4" class="mx-auto"></b-col>
            <b-col md="4" align="right" class="px-0">
              <b-pagination
                align="right"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <b-modal
      v-model="modalCreateShow"
      id="modal-prevent-closing"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      size="md"
    >
      <h4 class="text-capitalize">
        <b> Create Shorten URL </b>
      </h4>
      <br />
      <form data-vv-scope="form-create-shorten-url">
        <b-row>
          <b-col md="12">
            <b-form-group
              id="full-url-field-group"
              label="URL"
              label-for="full-url-field"
              class="mt-3"
            >
              <b-form-input
                id="full-url-field"
                name="url"
                placeholder="Enter URL"
                v-model="detail.url"
                v-validate="{required: true, url: true}"
                data-vv-as="URL"
                :formatter="toLowerCase"
                :disabled="loadingCreate"
              ></b-form-input>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("form-create-shorten-url.url") }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
      <br />
      <b-row>
        <b-col md="6"></b-col>
        <b-col>
          <b-button
            variant="light"
            @click="modalCreateShow = !modalCreateShow"
            class="text-primary"
            block
            size="lg"
            >Cancel</b-button
          >
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            :disabled="loadingCreate"
            @click="createShortenURL(detail)"
            block
            size="lg"
          >
            <b-spinner label="Spinning" v-show="loadingCreate"></b-spinner>Create
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      v-model="modalUpdateShow"
      id="modal-prevent-closing"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      size="md"
    >
      <h4 class="text-capitalize">
        <b> Update URL </b>
      </h4>
      <br />
      <form data-vv-scope="form-update-shorten-url">
        <b-row>
          <b-col md="12">
            <b-form-group
              id="update-shorted-url-field-group"
              label="Shorten URL"
              label-for="update-shorted-url-field"
              class="mt-3"
            >
              <b-form-input
                id="update-shorted-url-field"
                name="shorted_url"
                placeholder="Enter Shorten URL"
                v-model="detail.shorted_url"
                v-validate="{required: true, url: true}"
                data-vv-as="Shorten URL"
                :formatter="toLowerCase"
                disabled
              ></b-form-input>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("form-update-shorten-url.shorted_url") }}
              </p>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              id="update-url-field-group"
              label="URL"
              label-for="update-url-field"
              class="mt-3"
            >
              <b-form-input
                id="update-url-field"
                name="url"
                placeholder="Enter URL"
                v-model="detail.url"
                v-validate="{required: true, url: true}"
                data-vv-as="URL"
                :formatter="toLowerCase"
                :disabled="loadingUpdate"
              ></b-form-input>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("form-update-shorten-url.url") }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
      <br />
      <b-row>
        <b-col md="6"></b-col>
        <b-col>
          <b-button
            variant="light"
            @click="modalUpdateShow = !modalUpdateShow"
            class="text-primary"
            block
            size="lg"
            >Cancel</b-button
          >
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            :disabled="loadingUpdate"
            @click="updateShortenURL(detail)"
            block
            size="lg"
          >
            <b-spinner label="Spinning" v-show="loadingUpdate"></b-spinner>Update
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      errored: false,
      loading: false,
      createdAtStart: new Date(new Date().setDate(new Date().getDate() - 6)),
      createdAtEnd: new Date(Date.now()),
      key: [
        {
          key: "created_date_with_time",
          label: "Date | Time",
          sortable: false,
          class: "text-left w-9",
        },
        {
          key: "shorted_url",
          label: "Shorten URL",
          sortable: false,
          class: "text-center w-15",
        },
        {
          key: "url",
          label: "Full URL",
          sortable: false,
          class: "text-left w-15",
        },
        {
          key: "action",
          sortable: false,
          label: "",
          class: "text-center w-10",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      search_param: "",
      loadingCreate: false,
      modalCreateShow: false,
      loadingUpdate: false,
      modalUpdateShow: false,
      detail: {
        unique_code: "",
        shorted_url: "",
        url: "",
      },
      shorten_url: "",
    }
  },
  computed: {
    disabledDatesStart() {
      var disabledDates = {
        from: new Date(this.createdAtEnd + 8640000),
      };
      return disabledDates;
    },
    disabledDatesEnd() {
      var disabledDates = {
        to: new Date(this.createdAtStart - 8640000),
      };
      return disabledDates;
    },
  },
  methods: {
    toLowerCase(value) {
      return value.toLowerCase()
    },
    showModalCreate() {
      this.detail = {
        unique_code: "",
        shorted_url: "",
        url: "",
      };
      this.modalCreateShow = true;
    },
    showModalUpdate(item) {
      this.detail = {
        unique_code: item.unique_code,
        shorted_url: item.shorted_url,
        url: item.url,
      };
      this.modalUpdateShow = true;
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    resetDateCreatedStart() {
      this.createdAtStart = "";
    },
    resetDateCreatedEnd() {
      this.createdAtEnd = "";
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", this.search_param);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      formData.append(
        "created_from",
        this.createdAtStart != ""
          ? moment(this.createdAtStart).format("YYYY-MM-DD")
          : ""
      );
      formData.append(
        "created_to",
        this.createdAtEnd != ""
          ? moment(this.createdAtEnd).format("YYYY-MM-DD")
          : ""
      );
      this.$store
        .dispatch("ShortenerServiceModule/getShortenURLData", formData)
        .then((response) => {
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          callback([]);
        });
      return null;
    },
    createShortenURL(data) {
      this.loadingCreate = true;
      this.$validator.validateAll("form-create-shorten-url").then((result) => {
        if (result) {
          this.$store
            .dispatch("ShortenerServiceModule/createShortenURL", data)
            .then((response) => {
              this.loadingCreate = false;
              this.$refs.selectableTable.refresh();
              this.modalCreateShow = false;
              this.detail = {
                unique_code: "",
                shorted_url: "",
                url: ""
              }

              this.shorten_url = response.data.data.shortening_url || "";

              let htmlInput = `
              <div class="input-group">
                <input id="text_to_be_copied" class="form-control" readonly value=${this.shorten_url}>
                <div class="input-group-append">
                  <button type="button" class="btn btn-primary" id="btn-copy">Copy</button>
                </div>
              </div>
              `

              this.$swal({
                type: "success",
                title: "Short URL: ",
                html: htmlInput,
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonColor: "#d33",
                cancelButtonText: "Close",
                onOpen: () => {
                    document.getElementById("btn-copy").onclick = function() {
                      document.getElementById("text_to_be_copied").select();
                      document.execCommand("copy");
                    };
                }
              });
            })
            .catch((error) => {
              this.loadingCreate = false;
              this.modalCreateShow = false;
              this.shorten_url = "";
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500
              });
            });
        } else {
          this.loadingCreate = false;
          this.shorten_url = "";
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    },
    updateShortenURL(data) {
      this.loadingUpdate = true;
      this.$validator.validateAll("form-update-shorten-url").then((result) => {
        if (result) {
          this.$store
            .dispatch("ShortenerServiceModule/updateShortenURL", data)
            .then((response) => {
              this.loadingUpdate = false;
              this.$refs.selectableTable.refresh();
              this.modalUpdateShow = false;
              this.detail = {
                unique_code: "",
                shorted_url: "",
                url: ""
              }
              this.$swal("Updated!", "Your data has been updated.", "success");
            })
            .catch((error) => {
              this.loadingUpdate = false;
              this.modalUpdateShow = false;
              this.shorten_url = "";
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500
              });
            });
        } else {
          this.loadingUpdate = false;
          this.shorten_url = "";
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    },
    del(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          let uniqueCode = item.unique_code
          this.$store
            .dispatch("ShortenerServiceModule/deleteShortenURL", uniqueCode)
            .then((response) => {
              this.$refs.selectableTable.refresh();
              this.$swal("Deleted!", "Your data has been deleted.", "success");
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(error);
            });
        }
      });
    },
    resetSearch() {
      this.$refs.selectableTable.refresh();
      this.createdAtStart = "";
      this.createdAtEnd = "";
      this.search_param = "";
    },
    search() {
      this.$refs.selectableTable.refresh();
    },
  }
};
</script>